const setStore = (module, stateKey, value) => {

    if (localStorage.getItem('adminStore') == undefined) {
        let initValue = {
            admin: {},
            website: {},
        };
        localStorage.setItem('adminStore', JSON.stringify(initValue));
    }
    let cachedStore = JSON.parse(localStorage.getItem('adminStore'));
    const allKeys = stateKey.split(',');
   
    var createNestedObject = function (obj, keyPath, value) {
        let lastKeyIndex = keyPath.length - 1;
        for (var i = 0; i < lastKeyIndex; ++i) {
            let key = keyPath[i];
            if (!(key in obj)) {
                obj[key] = {}
            }
            obj = obj[key];
        }
        return obj[keyPath[lastKeyIndex]] = value;
        
    };
    createNestedObject(cachedStore[module], allKeys, value);
    // cachedStore[module][stateKey] = value;
    localStorage.setItem('adminStore', JSON.stringify(cachedStore))
    
}
export { setStore }